import { render, staticRenderFns } from "./news.vue?vue&type=template&id=adfc7f3c"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adfc7f3c')) {
      api.createRecord('adfc7f3c', component.options)
    } else {
      api.reload('adfc7f3c', component.options)
    }
    module.hot.accept("./news.vue?vue&type=template&id=adfc7f3c", function () {
      api.rerender('adfc7f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/competition/news.vue"
export default component.exports